import { c as _c } from "react/compiler-runtime";
import { ReadMore } from "ui/ReadMore";
import { Checkbox, type CheckboxProps } from "uiShadcn/checkbox";
import { FormControl, FormItem, FormLabel } from "uiShadcn/form";
import { cn } from "utils/helpers/cn";
interface IConsent extends Omit<CheckboxProps, "value"> {
  name: string;
  consent: string;
  value: boolean;
  dataTestId: string;
  readMoreInfo?: string;
}
export default function Consent(t0) {
  const $ = _c(13);
  const {
    name,
    consent,
    value,
    onCheckedChange,
    dataTestId,
    readMoreInfo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex items-start gap-n2");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== consent || $[2] !== dataTestId || $[3] !== name || $[4] !== onCheckedChange || $[5] !== value) {
    t2 = <FormControl><Checkbox name={name} checked={value} onCheckedChange={onCheckedChange} dataTestId={dataTestId} aria-label={consent} /></FormControl>;
    $[1] = consent;
    $[2] = dataTestId;
    $[3] = name;
    $[4] = onCheckedChange;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== consent || $[8] !== readMoreInfo) {
    t3 = <FormLabel><ReadMore text={consent} labelContext={readMoreInfo} /></FormLabel>;
    $[7] = consent;
    $[8] = readMoreInfo;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <FormItem className={t1}>{t2}{t3}</FormItem>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}